import gql from 'graphql-tag';

export const AlbumFolderForFeaturePermission = gql`
  query albumFolderForFeaturePermission($id: RecordID!) {
    albumFolder(id: $id) {
      id
      is_owner
      album_type
      album_subtype
    }
  }
`;

export const AlbumForFeaturePermission = gql`
  query albumForFeaturePermission($id: RecordID!) {
    album(id: $id) {
      id
      is_owner
      album_type
      album_subtype
    }
  }
`;
